import AddIcon from '@mui/icons-material/Add';
import { Button, Divider, Grid } from '@mui/material';
import React from 'react';

const AddDivider = (props) => {
    const onClick = (ev) => {
        props.onAdd && props.onAdd(props.idx, ev);
    }
    return (<React.Fragment>
        <Grid item xs={1}><Button onClick={onClick}><AddIcon/></Button></Grid>
        <Grid item xs={11} ><Divider variant="middle"/></Grid>
    </React.Fragment>);
}

export default AddDivider;
